import { mergeRefs } from "../../lib/utils";
import React, { HTMLAttributes, TableHTMLAttributes, forwardRef, useEffect, useRef, useState } from "react";

interface TabProps extends HTMLAttributes<HTMLDivElement> {
    value?: string;
    onValueChange?: (value:string) => void;
}

const Tab : React.FC<TabProps> = ({onValueChange, value, children, ...props}) => {
    const [domrect, setdomrect] = useState<{top:number, left:number, width:number, height:number}>();
    const parentRef = useRef<HTMLDivElement>()
    const activeRef = useRef<HTMLButtonElement>()

    useEffect(()=>{
        if(activeRef.current && parentRef.current){
            const parentRect = parentRef.current?.getBoundingClientRect()
            const rect = activeRef.current.getBoundingClientRect()
            const r = {
                top: rect.top - parentRect.top,
                left: rect.left - parentRect.left,
                width: rect.width,
                height: rect.height
            }
            setdomrect(r)
        }
        
    }, [value])

    const modifiedChildren = React.Children.map(children, (child:any, index) => {
        if(!child) return;
        
        return React.cloneElement(child, {
            isActive: value === child.props.value,
            onValueChange,
            ref: value===child.props.value ? activeRef : undefined
        })
    })

    return (
        <div ref={mergeRefs(parentRef)} {...props} className='inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground relative'>
            {modifiedChildren}
            <div style={{top:domrect?.top+'px', left:domrect?.left+'px', width:domrect?.width+'px', height:domrect?.height+'px'}} className="absolute z-0 duration-200 bg-background text-foreground shadow-sm rounded-sm"></div>
        </div>
    )
}

interface TabItemProps extends HTMLAttributes<HTMLButtonElement> {
    value?: string;
    isActive?: boolean;
    onValueChange?: (value:string) => void;
}

const TabItem = forwardRef<HTMLButtonElement, TabItemProps>(({value, onValueChange, isActive, children, ...props}, ref) => {
    
    const handleClick = () => {
        if(value && onValueChange) {
            onValueChange(value)
        }
    }

    return (
        <button ref={ref} {...props} onClick={()=>{ handleClick() }} data-state={isActive ? 'active' : 'inactive'} 
            className='z-[1] inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50'>
            {children}
        </button>
    )
})

export { Tab, TabItem }